import { render, staticRenderFns } from "./ParticularPagamentosPendentes.vue?vue&type=template&id=41d2cf17&"
import script from "./ParticularPagamentosPendentes.vue?vue&type=script&lang=js&"
export * from "./ParticularPagamentosPendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports